import { useCallback, useRef } from "react";
import { LEADERBOARD_TYPES, pageType } from ".";
import { useAppSelector } from "../../hooks/store-hooks";
import { Link } from "react-router-dom";
import { ROUTES } from "../../constants/routes";

export interface leaderboardRow {
  _id: string;
  user_id: {
    _id: string;
    first_name: string;
    last_name: string;
    profile_picture: string;
    company_name: string;
    designation: string;
  };
  entity: string;
  balance: number;
  active: boolean;
  percentile: number;
  weekly_gain?: number;
  daily_gain?: number;
}

const LeaderboardTable = ({
  leaderboardData,
  isLoading,
  type,
  setPage,
  isEnd,
}: {
  isEnd: boolean;
  type: LEADERBOARD_TYPES;
  isLoading: boolean;
  leaderboardData: leaderboardRow[];
  page: number;
  setPage: any;
}) => {
  const { homeData } = useAppSelector((state) => state.home || {});
  const { user: currentUser } = homeData || {};
  const observerRef = useRef<IntersectionObserver>();

  const lastPostElementRef = useCallback(
    (node: HTMLDivElement | null) => {
      if (isLoading || isEnd) return;
      if (observerRef.current) observerRef.current.disconnect();

      observerRef.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && !isEnd) {
          setPage((prevPage: pageType) => ({
            ...prevPage,
            [type]: prevPage[type] + 1,
          }));
        }
      });

      if (node) observerRef.current.observe(node);
    },
    [isLoading, isEnd],
  );
  return (
    <>
      <div className="grid grid-cols-8 rounded-lg content-stretch bg-white overflow-scroll">
        <div className="p-4 col-span-1">
          <span className="text-left text-[#808080] text-xs md:text-base">
            %ile
          </span>
        </div>
        <div className="p-4 col-span-6">
          <span className="text-left text-[#808080] text-xs md:text-base">
            Members
          </span>
        </div>
        <div className=" p-4 col-span-1">
          <div className="flex gap-1 w-full justify-end items-center">
            <img
              src="/assets/icons/star-red.png"
              alt=""
              className="ml-2 md:w-4 md:h-4 w-3 h-3"
            />
            <span className="text-[#808080] text-xs md:text-base">XP</span>
          </div>
        </div>
        {leaderboardData.map((row: leaderboardRow) => {
          return (
            <Link
              key={row._id}
              to={ROUTES.USER_PROFILE.replace(":user_id", row.user_id?._id)}
              className="contents"
            >
              <div
                className={`border-b p-4 col-span-1 flex justify-center items-center font-normal text-black ${row.user_id?._id === currentUser?._id ? "bg-[#F5ECCB]" : ""}`}
              >
                {row.percentile} {"%"}
              </div>
              <div
                className={`border-b p-4 col-span-6 ${row.user_id?._id === currentUser?._id ? "bg-[#F5ECCB]" : ""}`}
              >
                <div className="grid grid-rows-2 grid-flow-col w-max gap-x-3">
                  <img
                    src={row.user_id?.profile_picture}
                    alt={row.user_id?.first_name}
                    className="row-span-2 rounded-full w-10 h-10 md:h-[52px] md:w-[52px] object-cover"
                  ></img>
                  <div
                    className={
                      "text-[#090909] text-[22px] font-['SF Pro'] leading-7 "
                    }
                  >
                    {row.user_id?.first_name + " " + row.user_id?.last_name}
                  </div>
                  <div className="text-neutral-700 text-[15px] font-normal font-['SF Pro'] leading-tight">
                    {row.user_id?._id !== currentUser?._id
                      ? `${
                          row.user_id?.designation && row.user_id?.company_name
                            ? row.user_id?.designation +
                              " at " +
                              row.user_id?.company_name
                            : row.user_id?.designation ||
                              row.user_id?.company_name
                        }`
                      : "You"}
                  </div>
                </div>
              </div>
              <div
                className={`min-w-[100px] border-b p-4 col-span-1 flex justify-end items-center text-right text-[#090909] text-[22px] font-['SF Pro'] leading-7 ${row.user_id?._id === currentUser?._id ? "bg-[#F5ECCB]" : ""}`}
              >
                {type === "weekly"
                  ? row?.weekly_gain
                  : type === "daily"
                    ? row?.daily_gain
                    : row.balance}
              </div>
            </Link>
          );
        })}
        <div ref={lastPostElementRef}></div>
      </div>
    </>
  );
};
export default LeaderboardTable;
